import { useApiQuery } from 'mf_core/query';

export function useProfileData(resellerProspect = false) {
  return useApiQuery(`/account-management/v1/users/me`, undefined, {
    enabled: !resellerProspect,
  });
}
